// @ts-nocheck
import { createI18n } from 'vue-i18n';
import zhCN from './zh-CN';
import zhTW from './zh-TW';
import en from './en';
import es from './es';
import pt from './pt';
import ja from './ja';
import ko from './ko';
import fr from './fr';
import de from './de';
import ru from './ru';
import id from './id';
import ar from './ar';

const messages = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  en,
  es,
  pt,
  ja,
  ko,
  fr,
  de,
  ru,
  id,
  ar
};

function getBrowserLocale() {
  if (typeof localStorage !== 'undefined') {
    const savedLocale = localStorage.getItem('user-locale');
    if (savedLocale && Object.keys(messages).includes(savedLocale)) {
      return savedLocale;
    }
  }

  if (typeof navigator === 'undefined') return 'en';
  
  const language = navigator.language || 'en';
  const locales = Object.keys(messages);
  
  // Exact match
  if (locales.includes(language)) {
    return language;
  }
  
  // Base language match (e.g. en-US -> en)
  const [langCode] = language.split('-');
  if (locales.includes(langCode)) {
    return langCode;
  }
  
  // Special case for Chinese
  if (langCode === 'zh') {
    if (language.indexOf('TW') > -1 || language.indexOf('HK') > -1 || language.indexOf('MO') > -1) {
      return 'zh-TW';
    }
    return 'zh-CN';
  }
  
  return 'en';
}

const i18n = createI18n({
  legacy: false, // use Composition API
  locale: getBrowserLocale(), // default locale
  fallbackLocale: 'en',
  messages
});

export default i18n;
